import { render, staticRenderFns } from "./transRecord.vue?vue&type=template&id=7e57c39a&scoped=true"
import script from "./transRecord.vue?vue&type=script&lang=js"
export * from "./transRecord.vue?vue&type=script&lang=js"
import style0 from "./transRecord.vue?vue&type=style&index=0&id=7e57c39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e57c39a",
  null
  
)

export default component.exports